import React, { useEffect, useState } from 'react'
import { PageWrapper } from '../../components'
import { useLocation } from 'react-router-dom'

const isMobileDevice = () => {
	const ua = navigator.userAgent || navigator.vendor || window.opera
	return /android|iphone|ipad|ipod/i.test(ua)
}
const Redirect = () => {
	const [zip, setZip] = useState('')
	const [em, setEm] = useState('')
	const [dn, setDn] = useState('')
	const [est, setEst] = useState('')
	const [toc, setToc] = useState('')
	const [ic, setIc] = useState('')
	const [jobId, setJobId] = useState('')
	const [isMobile, setIsMobile] = useState(false)
	const location = useLocation()
	useEffect(() => {
		setIsMobile(isMobileDevice())
		if (location?.search) {
			const params = new URLSearchParams(location.search)

			const job = params.get('jobid') || '-'
			const zip = params.get('zip') || '-'
			const email = params.get('em') || '-'
			const supervisor = params.get('dn') || '-'
			const salesRep = params.get('est') || '-'
			const tearOffCrew = params.get('toc') || '-'
			const installCrew = params.get('ic') || '-'

			setZip(zip)
			setEm(email)
			setDn(supervisor)
			setEst(salesRep)
			setToc(tearOffCrew)
			setIc(installCrew)
			setJobId(job)

			const deeplink = `com.zeidos.romanroofing://add-visit/${encodeURIComponent(
				zip,
			)}/${encodeURIComponent(email)}/${encodeURIComponent(
				supervisor,
			)}/${encodeURIComponent(salesRep)}/${encodeURIComponent(
				tearOffCrew,
			)}/${encodeURIComponent(installCrew)}/${encodeURIComponent(job)}`

			if (
				/android|iphone|ipad|ipod/i.test(navigator.userAgent) &&
				job !== '-'
			) {
				setTimeout(() => {
					window.location.href = deeplink
				}, 250) // allow the page to render + give WKWebView time
			} else if (job !== '-') {
				setTimeout(() => {
					window.location.href = `https://www.nvoqe.com/apps/supervisor-job-visit?zip=${encodeURIComponent(
						zip,
					)}&em=${encodeURIComponent(email)}&dn=${encodeURIComponent(
						supervisor,
					)}&est=${encodeURIComponent(salesRep)}&toc=${encodeURIComponent(
						tearOffCrew,
					)}&ic=${encodeURIComponent(installCrew)}&jobid=${encodeURIComponent(
						job,
					)}`
				}, 250)
			}
		}
		return () => {}
	}, [location])

	const submitMobileHandler = () =>
		(window.location.href = `com.zeidos.romanroofing://add-visit/${zip}/${em}/${dn}/${est}/${toc}/${ic}/${jobId}`)

	// const submitDesktopHandler = () =>
	// 	(window.location.replace = `https://www.nvoqe.com/apps/supervisor-job-visit?zip=${encodeURIComponent(
	// 		zip,
	// 	)}&em=${encodeURIComponent(em)}&dn=${encodeURIComponent(
	// 		dn,
	// 	)}&est=${encodeURIComponent(est)}&toc=${encodeURIComponent(
	// 		toc,
	// 	)}&ic=${encodeURIComponent(ic)}&jobid=${encodeURIComponent(jobId)}`)

	return (
		<PageWrapper showNavigation={false}>
			{isMobile && (
				<>
					<p>Redirecting to app...</p>
					<div className='flex flex-col space-y-2'>
						<a
							href={`com.zeidos.romanroofing://add-visit/${zip}/${em}/${dn}/${est}/${toc}/${ic}/${jobId}`}
							style={{ color: 'blue', marginTop: 16, display: 'block' }}
						>
							Tap here if not redirected
						</a>
						<button
							className='py-2 w-[100px] border-1 border-gray-300 px-6 '
							onClick={submitMobileHandler}
						>
							Go To App
						</button>
					</div>
				</>
			)}
			{/* {!isMobile && (
				<>
					<p>Redirecting ...</p>
					<div className='flex flex-col space-y-2'>
						<a
							href={`https://www.nvoqe.com/apps/supervisor-job-visit?zip=${encodeURIComponent(
								zip,
							)}&em=${encodeURIComponent(em)}&dn=${encodeURIComponent(
								dn,
							)}&est=${encodeURIComponent(est)}&toc=${encodeURIComponent(
								toc,
							)}&ic=${encodeURIComponent(ic)}&jobid=${encodeURIComponent(
								jobId,
							)}`}
							style={{ color: 'blue', marginTop: 16, display: 'block' }}
						>
							Tap here if not redirected
						</a>
						<button
							className='py-2 w-[100px] border-1 border-gray-300 px-6 '
							onClick={submitDesktopHandler}
						>
							... Or tap here
						</button>
					</div>
				</>
			)} */}
		</PageWrapper>
	)
}

export default Redirect
